import { useEffect, useRef } from 'react'

export function useUnmount(callback: () => void) {
    const cbRef = useRef(callback)

    // Keep the latest callback without writing to refs during render
    useEffect(() => {
        cbRef.current = callback
    }, [callback])

    useEffect(
        () => () => {
            cbRef.current()
        },
        []
    )
}
